module.exports = __webpack_public_path__ + "img/jianbiandi.4f6e4117.png";